import React from "react";
import logo from "../../assets/images/brand/kido-logo.png";
import "./kidoLoader.css";

// The blue "O" from the logo bounces like a ball. Full-screen by default;
// `inline` covers only its positioned parent (e.g. the page body), and
// `overlay` is a see-through full-screen layer for in-progress actions.
const KidoLoader = ({ label = "Loading KIDO admin", inline = false, overlay = false }) => (
  <div
    className={
      "kd-loader" +
      (inline ? " kd-loader--inline" : "") +
      (overlay ? " kd-loader--overlay" : "")
    }
    role="status"
    aria-live="polite"
  >
    <div className="kd-loader-stage" aria-hidden="true">
      <span className="kd-loader-ball" />
      <span className="kd-loader-shadow" />
    </div>
    <img src={logo} alt="" className="kd-loader-logo" />
    <span className="kd-loader-sr">{label}</span>
  </div>
);

export default KidoLoader;
